// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-scrm {
  /* display: flex; */
  justify-content: space-around;
  width: 100%;
  /* height: 500px; */
  background-color: #202342;
}
.main-container-scrm .In-main-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.main-container-scrm .Heading-v {
  color: #fff;
  padding: 20px;
  font-size: 12px;
}

.sec-partition {
  /* margin-top: 20px; */
  border-top: 1px solid rgba(14, 190, 147, 1);
}

.mid-sec-partition {
   margin-top: 10px;
   border-top: 1px solid rgba(14, 190, 147, 1);
}

.mid-sec-head {
  margin-top: 10px;
}

.chatbot-container-main {
  display: flex;
  flex-direction: column;
  max-height: 80vh; /* Set a maximum height for the container */
  margin: auto; /* Center the container horizontally */
  overflow: hidden; /* Hide overflow content if it exceeds the maximum height */
}

.row-container {
  flex: 1 1; /* Make the row take up the available vertical space */
}

.right-section-chat-box,
.left-section-chat-box {
  flex: 1 1; /* Make both sections take up equal space within the row */
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  border-color: rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
  padding: 10px; /* Add padding for spacing if needed */
  min-height: 400px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  height: 73vh;
}

.scrm-change {
  margin-top:20px;
  height: 73vh;
}

.scrm-dropdown {
  background-color: rgba(37, 40, 67, 1);
    color: white;
    margin: 5px 10px;
}

.scrm-in-center {
    align-items: center;
    display: flex;
}

.scrm-in-center img {
  height: 21px;
  margin: 0px;
  padding: 0px;
  border-radius: 0px;
}

.multi-select{
  width: 80% !important;
  color: white;
  background-color: rgba(37, 40, 67, 1);
}

.multi-select div {
  background-color: rgba(37, 40, 67, 1) !important;
  color: white;
}

.css-1p3m7a8-multiValue {
  border: 1px solid white
}

.multi-select-send {
  float: right;
  margin-top: -34px;
}

.scrm-table th,
.scrm-table td {
  border: 1px solid black; /* You can change 'black' to any color you want */
  padding: 8px; /* Add padding for better appearance */
  text-align: left; /* Adjust text alignment as needed */
  font-size: 12px;
}

.right-section-chat-box {
  flex: 0.3 1; /* 30% of the available space */
}

.left-section-chat-box {
  flex: 0.7 1; /* 70% of the available space */
}

.custom-flex-col {
  flex: 0.3 1 !important;
}

/* .container {
  display: flex;
} */

.col-scrm {
  flex: 0 0 15% !important; /* This sets the first column to be 30% of the container */
  width: 15% !important;
  /* You can also add other styling properties if needed */
}

.col-scrm:nth-child(2) {
  flex: 1 1 !important; /* This sets the second column to take up the remaining space */
  /* You can also add other styling properties if needed */
}

.insight-button-scrm {
  width: auto;
  margin-left: 0px;
}

.insight-left-button-scrm {
  height:50px;
  min-width: 130px;
}

.bot-c-veg-scrm {
  max-width: 100% ;
}

.bot-c-veg-scrm .bg-bot-veg {
  max-width: 100%;
}

.remove-margin {
  margin: 0px;
}

.scrm-center-allign {
  align-items: center;
  display: flex;
}

.scrm-container {
  max-width: 100% !important;
}

.scrm-chat-fix {
  margin-top: 2px !important;
}

.send-icon-scrm {
     width:50px;
     display: flex;
     flex-direction: column;
     /* padding-top: 35px; */
}

.scrm-send-pos {
  padding-top: 15px;
}

.shift-right {
  float: right;
}

.image-container {
  text-align: left; /* Align the image to the left within its container */
}

.image-container img {
  width: 100%; /* Make the image fill the width of its container */
  display: block; /* Remove extra space beneath the image */
}`, "",{"version":3,"sources":["webpack://./src/Scrm.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;GACG,gBAAgB;GAChB,2CAA2C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,2CAA2C;EAC7D,YAAY,EAAE,sCAAsC;EACpD,gBAAgB,EAAE,2DAA2D;AAC/E;;AAEA;EACE,SAAO,EAAE,sDAAsD;AACjE;;AAEA;;EAEE,SAAO,EAAE,0DAA0D;EACnE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,aAAa,EAAE,sCAAsC;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;IACnC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB,EAAE,iDAAiD;EAC1E,YAAY,EAAE,sCAAsC;EACpD,gBAAgB,EAAE,oCAAoC;EACtD,eAAe;AACjB;;AAEA;EACE,WAAS,EAAE,+BAA+B;AAC5C;;AAEA;EACE,WAAS,EAAE,+BAA+B;AAC5C;;AAEA;EACE,sBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,wBAAwB,EAAE,0DAA0D;EACpF,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,oBAAkB,EAAE,+DAA+D;EACnF,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;KACK,UAAU;KACV,aAAa;KACb,sBAAsB;KACtB,uBAAuB;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,qDAAqD;AACzE;;AAEA;EACE,WAAW,EAAE,mDAAmD;EAChE,cAAc,EAAE,yCAAyC;AAC3D","sourcesContent":[".main-container-scrm {\r\n  /* display: flex; */\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  /* height: 500px; */\r\n  background-color: #202342;\r\n}\r\n.main-container-scrm .In-main-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n}\r\n.main-container-scrm .Heading-v {\r\n  color: #fff;\r\n  padding: 20px;\r\n  font-size: 12px;\r\n}\r\n\r\n.sec-partition {\r\n  /* margin-top: 20px; */\r\n  border-top: 1px solid rgba(14, 190, 147, 1);\r\n}\r\n\r\n.mid-sec-partition {\r\n   margin-top: 10px;\r\n   border-top: 1px solid rgba(14, 190, 147, 1);\r\n}\r\n\r\n.mid-sec-head {\r\n  margin-top: 10px;\r\n}\r\n\r\n.chatbot-container-main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 80vh; /* Set a maximum height for the container */\r\n  margin: auto; /* Center the container horizontally */\r\n  overflow: hidden; /* Hide overflow content if it exceeds the maximum height */\r\n}\r\n\r\n.row-container {\r\n  flex: 1; /* Make the row take up the available vertical space */\r\n}\r\n\r\n.right-section-chat-box,\r\n.left-section-chat-box {\r\n  flex: 1; /* Make both sections take up equal space within the row */\r\n  border-width: 1px;\r\n  border-style: solid;\r\n  border-radius: 10px;\r\n  border-color: rgba(116, 123, 169, 1);\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n  padding: 10px; /* Add padding for spacing if needed */\r\n  min-height: 400px;\r\n  margin-top: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 73vh;\r\n}\r\n\r\n.scrm-change {\r\n  margin-top:20px;\r\n  height: 73vh;\r\n}\r\n\r\n.scrm-dropdown {\r\n  background-color: rgba(37, 40, 67, 1);\r\n    color: white;\r\n    margin: 5px 10px;\r\n}\r\n\r\n.scrm-in-center {\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n.scrm-in-center img {\r\n  height: 21px;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.multi-select{\r\n  width: 80% !important;\r\n  color: white;\r\n  background-color: rgba(37, 40, 67, 1);\r\n}\r\n\r\n.multi-select div {\r\n  background-color: rgba(37, 40, 67, 1) !important;\r\n  color: white;\r\n}\r\n\r\n.css-1p3m7a8-multiValue {\r\n  border: 1px solid white\r\n}\r\n\r\n.multi-select-send {\r\n  float: right;\r\n  margin-top: -34px;\r\n}\r\n\r\n.scrm-table th,\r\n.scrm-table td {\r\n  border: 1px solid black; /* You can change 'black' to any color you want */\r\n  padding: 8px; /* Add padding for better appearance */\r\n  text-align: left; /* Adjust text alignment as needed */\r\n  font-size: 12px;\r\n}\r\n\r\n.right-section-chat-box {\r\n  flex: 0.3; /* 30% of the available space */\r\n}\r\n\r\n.left-section-chat-box {\r\n  flex: 0.7; /* 70% of the available space */\r\n}\r\n\r\n.custom-flex-col {\r\n  flex: 0.3 !important;\r\n}\r\n\r\n/* .container {\r\n  display: flex;\r\n} */\r\n\r\n.col-scrm {\r\n  flex: 0 0 15% !important; /* This sets the first column to be 30% of the container */\r\n  width: 15% !important;\r\n  /* You can also add other styling properties if needed */\r\n}\r\n\r\n.col-scrm:nth-child(2) {\r\n  flex: 1 !important; /* This sets the second column to take up the remaining space */\r\n  /* You can also add other styling properties if needed */\r\n}\r\n\r\n.insight-button-scrm {\r\n  width: auto;\r\n  margin-left: 0px;\r\n}\r\n\r\n.insight-left-button-scrm {\r\n  height:50px;\r\n  min-width: 130px;\r\n}\r\n\r\n.bot-c-veg-scrm {\r\n  max-width: 100% ;\r\n}\r\n\r\n.bot-c-veg-scrm .bg-bot-veg {\r\n  max-width: 100%;\r\n}\r\n\r\n.remove-margin {\r\n  margin: 0px;\r\n}\r\n\r\n.scrm-center-allign {\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n\r\n.scrm-container {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.scrm-chat-fix {\r\n  margin-top: 2px !important;\r\n}\r\n\r\n.send-icon-scrm {\r\n     width:50px;\r\n     display: flex;\r\n     flex-direction: column;\r\n     /* padding-top: 35px; */\r\n}\r\n\r\n.scrm-send-pos {\r\n  padding-top: 15px;\r\n}\r\n\r\n.shift-right {\r\n  float: right;\r\n}\r\n\r\n.image-container {\r\n  text-align: left; /* Align the image to the left within its container */\r\n}\r\n\r\n.image-container img {\r\n  width: 100%; /* Make the image fill the width of its container */\r\n  display: block; /* Remove extra space beneath the image */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
